import { OnboardingStep } from '../onboarding/onboarding.type';

export enum UserRole {
  SoftwareEngineer = 'softwareEngineer',
  Founder = 'founder / entrepreneur',
}

export enum Gender {
  Man = 'Man',
  Woman = 'Woman',
  NonBinary = 'Non-binary',
  PreferNotToSay = 'Prefer not to say',
}

export enum QualificationLevel {
  BSc = 'BSc',
  MSc = 'MSc',
  PhD = 'PhD',
  Diploma = 'Diploma',
  Certificate = 'Certificate',
  AssociateDegree = 'Associate Degree',
}

export enum ProjectStages {
  EarlyIdeation = 'In Early ideation stage',
  ClearRequirements = 'Has Clear requirements defined',
  OperationalWithClients = 'Is Operational with clients',
}

export enum ProjectRoles {
  ExploreFeasibility = 'Explore Feasibility',
  BuildMVP = 'Build an MVP / Prototype',
  ExpandExistingWork = 'Expand Existing Work',
}

export enum Timeframe {
  PartTime = 'Part-Time Basis',
  FullTime = 'Full-Time Basis',
  Flexible = 'Flexible Basis',
}

export enum Compensation {
  Equity = 'Equity Only',
  Cash = 'Cash Only',
  EquityAndCash = 'Equity & Cash',
}

export type RecentProject = {
  name: string;
  description: string;
  lastUpdated: any;
  projectImage: string;
  techStack?: string[];
  developerTechStack?: string[];
  projectCategory?: string[];
}

export type Verification = {
  linkedInProfileUrl?: string;
  verificationCV?: string;
  verificationCvDescription?: string;
  verificationDocument?: string;
  verificationDocumentDescription?: string;
}

export type PTestAnswerType = {
  questionId: string;
  answer: number;
  category: string;
  isFlipped: boolean;
}

export type PTestResultsType = {
  answers: PTestAnswerType[];
  personality_code: string;
  resilienceFlag: string;
  totalScore: number;
}

export type WebOnboarding = {
  appliedFor?: string;
  optedIn?: boolean;
  meetingInviteSent?: boolean;
  onboardingStep?: OnboardingStep;
}

export type UserProfile = {
  uid: string;
  email: string;
  firstName?: string;
  lastName?: string;
  matchaPoints?: number;
  isProfileCompleted?: boolean;
  hasVerifiedPhoneNumber?: boolean;
  hasCompletedProfileInfo?: boolean;
  hasCompletedLookingFor?: boolean;
  hasCompletedProfessionalDescriptionPage?: boolean;
  hasCompletedPTest?: boolean;
  hasSubmittedDocumentsForVerification?: boolean;
  hasAccess?: boolean;
  hasVisitedPaywall?: boolean;
  profileImageUrl?: string;
  phone?: string;
  city?: string;
  gender?: Gender;
  createdAt: any;
  updatedAt: any;
  about?: string;
  role?: UserRole;
  recentProject?: RecentProject;
  longDescription?: string;
  skills?: string[];
  notableCompanies?: string[];
  yearsOfExperience?: number;
  isStudent?: boolean;
  degrees?: string[];
  target_role?: ProjectRoles | undefined;
  project_stage?: ProjectStages | undefined;
  timeframe?: Timeframe | undefined;
  compensation?: Compensation | undefined;
  verification?: Verification;
  webOnboarding?: WebOnboarding;
  personality_results?: PTestResultsType | null;
  hasSeenWelcomeAgreement?: boolean;
  hasAgreedToProTerms?: boolean | null;
}

export type CreateUserData = Omit<UserProfile, 'uid' | 'createdAt' | 'updatedAt'>;
export type UpdateUserData = Partial<Omit<UserProfile, 'uid' | 'createdAt'>>;

